import React, { Component } from 'react'

// redux
import Button from '../../components/uielements/button'
import { connect } from 'react-redux'
import mediaActions from '../../redux/component_select_media/actions'
import { Form, Input, Switch, Upload, Icon, message } from 'antd'
import { FaTimes, FaPlus, FaSave } from 'react-icons/fa'

class MediaInfoForm extends Component {
    state = {
        file: null,
        fileList: [],
    }

    // helper
    equalArray = (arr1, arr2) => {
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
        if (arr1.length !== arr2.length) return false
        for (let index = 0; index < arr1.length; index++)
            if (arr1[index] !== arr2[index]) return false

        return true
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1
    }

    // update new props
    componentWillReceiveProps(nextProps) {
        if (nextProps.media !== this.props.media) {
            const { form, media } = nextProps

            this.setState({
                countId: media.hashtag.length,
            })

            form.setFieldsValue({
                tags: [],
                names: [],
            })

            const tags = media.hashtag
            for (let index = 0; index < tags.length; index++) {
                const keys = form.getFieldValue('tags')
                const nextKeys = keys.concat(index)
                form.setFieldsValue({
                    tags: nextKeys,
                })
            }

            form.setFieldsValue({
                names: tags,
            })
        }
    }

    componentDidMount() {
        const { form, media } = this.props
        this.setState({
            countId: media.hashtag.length,
        })

        form.setFieldsValue({
            tags: [],
            names: [],
        })

        if (media.media_id !== 0) this.setState({ fileList: [] })

        const tags = media.hashtag
        for (let index = 0; index < tags.length; index++) {
            const keys = form.getFieldValue('tags')
            const nextKeys = keys.concat(index)
            form.setFieldsValue({
                tags: nextKeys,
            })
        }

        form.setFieldsValue({
            names: tags,
        })
    }

    // event
    onSubmit = e => {
        // e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.fileList.length === 0 &&
                    this.props.media.media_id === 0
                ) {
                    message.error('Bạn phải lựa chọn file upload')
                    return
                }

                if (this.state.fileList[0]) {
                    const { name } = this.state.fileList[0]
                    this.props.updateCurrentMedia({ name })
                }

                this._handleUpdateCurrentTag()

                this.props.saveCurrentMedia()
                this.props.dismiss()

                this.setState({ fileList: [] })
            }
        })
    }

    // handle
    _handleUpdateCurrentTag = () => {
        console.log('start')
        try {
            const { form } = this.props
            const names = form.getFieldValue('names')
            const keys = form.getFieldValue('tags')

            console.log('step 1')
            console.log('Names : ', names)
            console.log('Keys : ', keys)

            if (names.length < keys.length) return

            console.log('step 2')

            const nextNames = names.filter((tag, index) => {
                if (!this.isInArray(index, keys)) {
                    return false
                }
                if (typeof tag === undefined) return false
                if (tag === '') return false
                return true
            })

            console.log('step 3')

            console.log('next names : ', nextNames)
            if (this.equalArray(this.props.media.hashtag, nextNames) === false)
                this.props.updateCurrentMedia({ hashtag: nextNames })
        } catch {}
    }

    _handleAddTag = () => {
        const { form } = this.props
        const keys = form.getFieldValue('tags')
        const nextKeys = keys.concat(this.state.countId)
        form.setFieldsValue({
            tags: nextKeys,
        })

        this.setState({ countId: this.state.countId + 1 })
    }

    _handleDelete = id => {
        const { form } = this.props
        const keys = form.getFieldValue('tags')
        const nextKeys = keys.filter(key => key !== id)
        const namesData = form.getFieldValue('names')
        const nextName = namesData.filter((item, index) => {
            return index != id
        })
        form.setFieldsValue({
            tags: nextKeys,
        })
        this.props.updateCurrentMedia({ hashtag: nextName })

    }

    _handleChangeFileUpload = info => {
        if (info.file.status === 'done') {
            this.props.updateFile(info.file.originFileObj)
        }

        let fileList = [...info.fileList]

        fileList = fileList.slice(-1)

        // 2. Read from response and show file link
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                const url = file.response
                if (url[0] === 'h' && url[1] === 't') file.url = file.response
            }
            return file
        })

        this.setState({ fileList })
    }

    customRequest = ({ file, onSuccess, onError }) => {
        setTimeout(() => {
            // uploadMediaFile(file).then(response => {
            //     console.log("response : ", response)
            //     const avatar = response.uploaded_files[0]
            //     console.log(avatar)

            //     if (avatar[0] !== 'h' || avatar[1] !== 't')
            //         onError(avatar)

            //     onSuccess(avatar)
            // })
            // .catch(error => onError(error))

            if (file.size > 400000000)
                onError('Kích thước tối đa là 400 MB', file)
            onSuccess('ok', file)
        }, 0)
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form
        const { media } = this.props

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 24, offset: 24 },
                sm: { span: 16, offset: 8 },
            },
        }

        getFieldDecorator(`tags`, { initialValue: [] })
        const tags = getFieldValue('tags')
        const formItems = Array.isArray(tags)
            ? tags.map((k, index) => (
                  <Form.Item
                      {...(index === 0
                          ? formItemLayout
                          : formItemLayoutWithOutLabel)}
                      label={index === 0 ? 'Thẻ' : ''}
                      required={false}
                      key={k}
                  >
                      {getFieldDecorator(`names[${k}]`, {
                          validateTrigger: ['onChange', 'onBlur'],
                          rules: [
                              {
                                  required: true,
                                  whitespace: true,
                                  message: 'Xin mời nhập nội dung thẻ',
                              },
                          ],
                          initialValue: media.hashtag[index]
                              ? media.hashtag[index]
                              : '',
                      })(
                          <Input
                              placeholder="Tên thẻ"
                              style={{
                                  width: '60%',
                                  marginRight: 8,
                                  marginBottom: 3,
                                  marginTop: 3,
                              }}
                          />
                      )}
                      <FaTimes onClick={() => this._handleDelete(k)} />
                  </Form.Item>
              ))
            : null

        let buttonUpload = (
            <Button style={{ border: '1px solid' }}>
                <Icon type="upload" /> Click to Upload
            </Button>
        )

        const uploadFile = (
            <Form.Item label="File">
                <Upload
                    name="file"
                    showUploadList={true}
                    multiple={false}
                    customRequest={this.customRequest}
                    onChange={this._handleChangeFileUpload}
                    fileList={this.state.fileList}
                >
                    {this.state.fileList.length > 0 ? null : buttonUpload}
                </Upload>
            </Form.Item>
        )

        const filename = <Form.Item label="File">{media.name}</Form.Item>

        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                {media.media_id === 0 ? uploadFile : filename}
                {formItems}
                <Form.Item {...formItemLayoutWithOutLabel}>
                    <Button
                        onClick={() => this._handleAddTag()}
                        style={{
                            width: '60%',
                            border: '1px solid blue',
                            color: 'blue',
                            marginBottom: 20,
                        }}
                    >
                        <FaPlus style={{ marginRight: 5 }} /> Thêm thẻ
                    </Button>
                </Form.Item>
                <Form.Item wrapperCol={{ span: 15, offset: 11 }}>
                    <Button
                        size="large"
                        // htmlType="submit"
                        onClick={() => this.onSubmit()}
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Lưu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => {
                            this.setState({ fileList: [] })
                            this.props.onCancel()
                        }}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

const WrappedMediaInfoForm = Form.create({ name: 'mediaInfo' })(MediaInfoForm)

const mapStateToProps = state => {
    console.log('---  state --- ', state)
    return {
        media: state.component_select_media.currentMedia,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateCurrentMedia: media => {
            dispatch(mediaActions.action.updateCurrentMedia(media))
        },
        updateFile: file => {
            dispatch(mediaActions.action.updateFile(file))
        },
        saveCurrentMedia: () => {
            dispatch(mediaActions.action.saveCurrentMedia())
        },
        dismiss: () => {
            dispatch(mediaActions.action.dismissModalCurrentMediaInfo())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WrappedMediaInfoForm)
